export class FormElements {
    public datosEmpresa: boolean;
    public datosObra: boolean;
}
